import type { NotificationReport } from 'c-entity-types';
import { baseInitialState, createBaseSlice } from 'c-data';
import type { NotificationReportState } from './NotificationReport-types';

const initialState: NotificationReportState = { ...baseInitialState };

const additionalReducers = {
    // no extra reducers
};

const slice = createBaseSlice<
    NotificationReport,
    NotificationReportState,
    typeof additionalReducers
>({
    name: 'notificationReport',
    entityName: 'NotificationReport',
    initialState,
    reducers: additionalReducers,
});

const notificationReportSlice = {
    notificationReportActions: slice.slice.actions,
    notificationReportReducer: slice.slice.reducer,
    notificationReportAdapter: slice.adapter,
    notificationReportSelectors: slice.selectors,
    notificationReportThunks: slice.thunks,
};

export const {
    notificationReportReducer,
    notificationReportActions,
    notificationReportAdapter,
    notificationReportSelectors,
    notificationReportThunks,
} = notificationReportSlice;
